export const PostalNames = {
  InvoiceFormPopupOverlay: 'invoice-form-popup-overlay',
  SlideOutContainer: 'slide-out-container',
  SlideOutContainerLayer1: 'slide-out-container-layer-1',
  SlideOutContainerLayer2: 'slide-out-container-layer-2',
  SlideOutContainerLayer3: 'slide-out-container-layer-3',
  PreloaderOverlay: 'preloader-overlay'
}
